import React from 'react';
import { DynamicModuleLoader } from 'redux-dynamic-modules';
import { getUtilizationModule } from 'UtilizationModule/package/utilizationModule';

const LoadUtilizationModule = () => (
  <DynamicModuleLoader modules={[getUtilizationModule()]} />
);
export default LoadUtilizationModule;
